function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var SvgStorm = function SvgStorm(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 481.12 481.12",
    style: {
      enableBackground: "new 0 0 481.12 481.12"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#77B9C8"
    },
    d: "M427.2,162.4c-1.12,0-42.744,0-42.744,0c0.744-8,1.24-11.184,1.256-15.976 c0.128-42.768-28.424-81.376-70.192-90.584c-23.808-5.248-46.536-1.984-65.336,8.16C227.248,29.856,189.232,6.52,145.672,3.856 c-5.608-0.768-11.28-1.384-17.096-1.384C57.568,2.472,0,61.8,0,135.032c0,38.16,15.72,72.432,40.744,96.624 c22.12,24.544,52.84,40.384,89.216,43.024c0,0,296.12,1.464,297.24,1.464c29.776,0,53.92-24.8,53.92-56.872 C481.12,187.2,456.976,162.4,427.2,162.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92C7D3"
    },
    d: "M34.552,478.648c-1.36,0-2.736-0.344-3.992-1.072c-3.832-2.208-5.144-7.104-2.928-10.928l28-48.496 c2.208-3.832,7.112-5.144,10.928-2.928c3.832,2.208,5.144,7.104,2.928,10.928l-28,48.496 C40.008,477.216,37.32,478.648,34.552,478.648z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92C7D3"
    },
    d: "M82.552,478.648c-1.36,0-2.736-0.344-3.992-1.072c-3.832-2.208-5.144-7.104-2.928-10.928l28-48.496 c2.208-3.832,7.112-5.144,10.928-2.928c3.832,2.208,5.144,7.104,2.928,10.928l-28,48.496 C88.008,477.216,85.32,478.648,82.552,478.648z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92C7D3"
    },
    d: "M130.552,478.648c-1.36,0-2.736-0.344-3.992-1.072c-3.832-2.208-5.144-7.104-2.928-10.928l28-48.496 c2.208-3.832,7.104-5.144,10.928-2.928c3.832,2.208,5.144,7.104,2.928,10.928l-28,48.496 C136.008,477.216,133.32,478.648,130.552,478.648z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92C7D3"
    },
    d: "M178.552,478.648c-1.36,0-2.736-0.344-3.992-1.072c-3.832-2.208-5.144-7.104-2.928-10.928l28-48.496 c2.208-3.832,7.112-5.144,10.928-2.928c3.832,2.208,5.144,7.104,2.928,10.928l-28,48.496 C184.008,477.216,181.32,478.648,178.552,478.648z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92C7D3"
    },
    d: "M370.552,478.648c-1.36,0-2.736-0.344-3.992-1.072c-3.832-2.208-5.144-7.104-2.928-10.928l28-48.496 c2.208-3.832,7.112-5.144,10.928-2.928c3.832,2.208,5.144,7.104,2.928,10.928l-28,48.496 C376.008,477.216,373.32,478.648,370.552,478.648z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92C7D3"
    },
    d: "M322.552,478.648c-1.36,0-2.736-0.344-3.992-1.072c-3.832-2.208-5.144-7.104-2.928-10.928l28-48.496 c2.216-3.832,7.104-5.144,10.928-2.928c3.832,2.208,5.144,7.104,2.928,10.928l-28,48.496 C328.008,477.216,325.32,478.648,322.552,478.648z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92C7D3"
    },
    d: "M418.552,478.648c-1.36,0-2.736-0.344-3.992-1.072c-3.832-2.208-5.144-7.104-2.928-10.928l28-48.496 c2.208-3.832,7.104-5.144,10.928-2.928c3.832,2.208,5.144,7.104,2.928,10.928l-28,48.496 C424.008,477.216,421.32,478.648,418.552,478.648z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDC567"
    },
    points: "88.272,369.2 113.768,298.992 68.904,273.088 171.472,159.464 144.104,259.04  201.624,292.248  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDC567"
    },
    points: "260.616,452.152 286.112,381.944 241.248,356.04 343.816,242.416 316.448,341.984  373.968,375.192  "
  })), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStorm, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/storm.4b969a4c.svg";
export { ForwardRef as ReactComponent };